var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrap",on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":"/loader.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }